import { useState } from "react";
import { formatDate } from "src/Common/common";
import ConfirmDialog from "src/Common/confirmdialog";
import DropDown from "src/Components/EditDeleteDropdown/dropdown";

function VendorTable({ vendors, onDeleteVendor, onEditClicked, canEdit = true, canDelete = true }) {
  const [isDeleteConfirmDialogShown, setIsDeleteConfirmDialogShown] = useState(false);
  const [indexForDeletion, setIndexForDeletion] = useState(0);

  const deleteClicked = (index) => {
    setIsDeleteConfirmDialogShown(true);
    setIndexForDeletion(index);
  };

  const editClicked = (index) => {
    onEditClicked(index);
  };

  return (
    <div>
      {isDeleteConfirmDialogShown && (
        <ConfirmDialog
          title="DELETE VENDOR"
          description="Are you sure you want to delete this?"
          shown={isDeleteConfirmDialogShown}
          onConfirmClicked={() => {
            onDeleteVendor(indexForDeletion);
            setIsDeleteConfirmDialogShown(false);
          }}
          onCancelClicked={() => setIsDeleteConfirmDialogShown(false)}
        />
      )}

      <div
        className="w-full flex flex-col overflow-hidden max-h-[calc(100vh-220px)]"
        style={{
          borderRadius: "12px",
          border: "1px solid #E5E8F3",
          background: "#FFF",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.00), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
          <table className="w-full">
            <thead className="sticky top-0 z-10">
              <tr
                style={{ borderBottom: "1px solid #E5E8F3", background: "#F8F9FE" }}
                className="[&>th]:border-r [&>th]:border-borderColor [&>th:last-child]:border-r-0"
              >
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                    <span>Name</span>
                  </div>
                </th>
                <th className="w-[180px]">
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 h-[44px] text-[#5F6477]">
                    Date Added
                  </div>
                </th>
                <th className="w-[48px]"></th>
              </tr>
            </thead>
            <tbody>
              {vendors.map((vendor, i) => (
                <tr
                  key={i}
                  className="border-b border-borderColor hover:bg-[#FAFAFB] [&>td]:border-r [&>td]:border-borderColor [&>td:last-child]:border-r-0"
                >
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] col-span-1">
                      {vendor.name}
                    </div>
                  </td>

                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] col-span-1">
                      {formatDate(vendor.createdAt)}
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center justify-center px-2 py-3">
                      <DropDown index={i} onDeleteClicked={deleteClicked} onEditClicked={editClicked} canEdit={canEdit}
                                canDelete={canDelete}/>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default VendorTable;
